<div class="title-bar">
	<nav aria-label="breadcrumb">
		<ol class="breadcrumb">
			<li class="breadcrumb-item">
				<fa-icon [icon]="ac.sectionIcons.licensingadmin" class="cp-admin-nav-item me-1" size="sm">
				</fa-icon>
				Licensing
			</li>
			<li class="breadcrumb-item active" aria-current="page">Templates</li>
		</ol>
	</nav>

	<div class="actions">
		<div class="form-inline">
			<div *ngIf="canManageTemplates" class="btn-group me-1 dropstart">
				<button class="btn btn-outline-primary dropdown-toggle" type="button" id="newTemplateButton" data-bs-toggle="dropdown"
					aria-haspopup="true" aria-expanded="false">
					<fa-icon [icon]="['fas', 'plus']" size="sm"></fa-icon>
					<span class="cp-action-button-text">New Template</span>
				</button>
				<div class="dropdown-menu cp-scrollable-menu" aria-labelledby="newTemplateButton">
					<a *ngFor="let item of products" class="dropdown-item" href="#" [routerLink]="['new', item.name]">
						{{ item.label }} ({{ item.name }})
					</a>
				</div>
			</div>

			<button type="button" class="btn btn-outline-secondary" (click)="getData(true)">
				<fa-icon icon="sync-alt" size="sm" [spin]="loading" ngbTooltip="Refresh" placement="start"></fa-icon>
				<!-- <span class="cp-action-button-text">Refresh</span> -->
			</button>
		</div>
	</div>
</div>

<button (click)="ut.scrollToSpot('top-of-list')" id="top-of-list-button" class="cp-scroll-to-top-end d-none" title="Go to top">
	<fa-icon [icon]="['fas', 'angle-up']"></fa-icon>Top
</button>
<div class="list-wrapper" id="list-page-id" (scroll)="ut.onDivScrollHandler('top-of-list-button', 'list-page-id')">
	<div id="top-of-list"></div>
	<div *ngIf="loading" style="text-align: center;">
		<app-loading-spinner></app-loading-spinner>
	</div>

	<app-paging-search-bar [parentApi]="getParentMethod()" [centered]="false"></app-paging-search-bar>

	<table *ngIf="!loading && itemsToShow.length > 0" class="cp-std-table cp-auto-width">
		<thead>
			<tr app-column-headings [parentApi]="getParentMethod()" [columnDefs]="columnDefs" [fieldsToShow]="fieldsToShow"
				[displayOptions]="displayOptions">
			</tr>

		</thead>

		<tbody *ngIf="itemsToShow && !loading">
			<tr *ngFor="let item of itemsToShow">
				<td class="cp-icon-cell">
					<fa-icon *ngIf="!item.settings.editOnly" [icon]="['fas', 'plus']" size="sm"
						ngbTooltip="Can be used to add and/or edit keys" placement="bottom-start">
					</fa-icon>
					<fa-icon *ngIf="item.settings.editOnly" [icon]="['fas', 'pencil']" size="sm"
						ngbTooltip="Cannot be used to create new keys" placement="bottom-start">
					</fa-icon>
				</td>
				<td class="text-center">
					{{ item.num_keys | number }}
				</td>
				<td class="cp-icon-cell">
					<fa-icon *ngIf="userTemplateIDs.includes(item.id)" [icon]="['fas', 'check']" size="sm"
						ngbTooltip="You can use this template" placement="bottom-start">
					</fa-icon>
				</td>
				<td class="text-nowrap">
					<a [routerLink]="[item.id]" [ngbPopover]="templatePopupContent" popoverClass="cp-popover-std"
						triggers="mouseenter:mouseleave" container="body">
						{{ item.name }}
					</a>
				</td>
				<!-- <td>{{ template.description }}</td> -->
				<td class="text-nowrap">{{ niceKeyProduct(item.product) }}</td>
				<td class="text-center">
					<span [ngbTooltip]="item['__types_full']">
						{{ item['__types'] }}
					</span>
				</td>
				<td class="text-nowrap text-center">
					{{ item.added_on | timeback }}
				</td>
				<td class="text-nowrap text-center">
					{{ item.edited_on | timeback }}
				</td>

				<ng-template #templatePopupContent>
					<app-card-key-template [object]="item"></app-card-key-template>
					<!-- <div class="cp-popover-banner">{{ item.name }}</div>
					<div class="cp-pre-text">{{
						popOverTools.getKeyTemplatePopoverLines(item).join('\n')}}</div> -->
				</ng-template>


			</tr>
		</tbody>
	</table>
	<app-paging-bar [parentApi]="getParentMethod()" [pageNum]="displayOptions.pageNum" [pagingOptions]="pagingOptions"
		[centered]="false"></app-paging-bar>

</div>